// extracted by mini-css-extract-plugin
export default {"headerBar":"GI-z","pointsSection":"HI-z","goToDashboard":"II-z"};